'use client';

import Link from 'next/link';
import { useChunkLoadRecovery } from '@/lib/use-chunk-load-recovery';

export default function SearchError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useChunkLoadRecovery(error);

	return (
		<div className="container-page flex min-h-[60vh] flex-col items-center justify-center text-center">
			<h1 className="text-6xl font-bold text-neutral-900">Error</h1>
			<p className="mt-4 text-lg text-neutral-600">Search couldn&apos;t be loaded right now.</p>
			<div className="mt-8 flex items-center gap-4">
				<button
					type="button"
					onClick={reset}
					className="inline-flex items-center rounded-md bg-neutral-900 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-neutral-800"
				>
					Try Again
				</button>
				<Link
					href="/"
					className="inline-flex items-center rounded-md border border-neutral-300 px-6 py-3 text-sm font-medium text-neutral-700 transition-colors hover:bg-neutral-50"
				>
					Back to Home
				</Link>
			</div>
		</div>
	);
}
